import { useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useAuth } from '../context/AuthContext';
import { markOnboardingSeen } from '../api/users';
import { openExternalUrl } from '../utils/openUrl';
import { GradientCard } from './ui';
import { fonts, gradients } from '../theme';

const GUIDE_URL = 'https://loot.com.vn/huong-dan.html';

/** No-reward onboarding nudge — opens the same guide page already linked
 * from Profile, just surfaced up front for brand-new users. Marks itself
 * seen (server-side) on open, so it only shows once. */
export function OnboardingGuideCard() {
  const { token, user, refreshUser } = useAuth();
  const [dismissing, setDismissing] = useState(false);
  if (!user || user.onboardingSeenAt || dismissing) return null;

  const onPress = async () => {
    setDismissing(true);
    openExternalUrl(GUIDE_URL);
    if (token) {
      try {
        await markOnboardingSeen(token);
        await refreshUser();
      } catch {
        // Non-critical — worst case the card reappears next visit.
      }
    }
  };

  return (
    <Pressable onPress={onPress}>
      <GradientCard colors={gradients.primary} style={{ marginBottom: 16, flexDirection: 'row', alignItems: 'center', gap: 12 }}>
        <View
          style={{
            width: 40,
            height: 40,
            borderRadius: 12,
            backgroundColor: 'rgba(255,255,255,0.2)',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Ionicons name="book-outline" size={20} color="#fff" />
        </View>
        <View style={{ flex: 1 }}>
          <Text style={{ fontSize: 15, fontFamily: fonts.bold, color: '#fff' }}>
            Xem hướng dẫn nhanh (2 phút)
          </Text>
          <Text style={{ color: 'rgba(255,255,255,0.85)', fontSize: 12.5, marginTop: 2 }}>
            Cách nhận nhiệm vụ, check-in và rút tiền
          </Text>
        </View>
        <Ionicons name="chevron-forward" size={18} color="rgba(255,255,255,0.85)" />
      </GradientCard>
    </Pressable>
  );
}
